import DealBreakers from "./DealBreakers";

export default DealBreakers;
